// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error__switch[data-v-c51056e8]{color:#b64351!important}.element__error[data-v-c51056e8] .v-input--switch__thumb,.element__error[data-v-c51056e8] .v-input--switch__track{border:2px solid #b64351!important}", ""]);
// Exports
module.exports = exports;
